import { Route, Switch } from "react-router-dom";
import AtendimentoCliente from "../../Pages/AtendimentoCliente/Atendimento";
import { GestaoAtendimentoAoCliente } from "../../Pages/AtendimentoCliente/GestaoDeAtendimentos";
import { RelatoriosBIAtendimentoCliente } from "../../Pages/AtendimentoCliente/RelatoriosBI";
import { RelatoriosBIPerfilClientes } from "../../Pages/AtendimentoCliente/RelatoriosBIPerfilClientes";
import ModuloADS from "../../Pages/ModuloAds";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import { RelatoriosBICSATAtendimento } from "../../Pages/AtendimentoCliente/RelatoriosBICSATAtendimento";
import { RelatoriosBINPSAtendimento } from "../../Pages/AtendimentoCliente/RelatoriosBINPSAtendimento";
import AgendaAtividadesComponent from "../../Pages/Geral/Agenda/Agenda";
import PesquisaSatisfacaoAtendimentoCliente from "../../Pages/AtendimentoCliente/PesquisaSatisfacaoAtendimentoCliente/PesquisaSatisfacaoAtendimentoCliente";

export default function RotasAtendimento() {
    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.ATENDIMENTO.TELAS.DASHBOARD.DS_PATH}
                component={() => <></>}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={ACESSOS.ATENDIMENTO.TELAS.DASHBOARD.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS
                        .MEUS_ATENDIMENTOS.DS_PATH
                }
                component={GestaoAtendimentoAoCliente.MeusAtendimentos}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
            />
            <PrivatedRoute
                path={
                    ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.GRUPO.DS_PATH
                }
                component={GestaoAtendimentoAoCliente.AtendimentoGrupo}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={
                    ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.GRUPO.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.TODOS.DS_PATH
                }
                component={GestaoAtendimentoAoCliente.TodosAtendimentos}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={
                    ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.TODOS.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.ATENDIMENTO.TELAS.ATENDIMENTO.DS_PATH}
                component={AtendimentoCliente}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={ACESSOS.ATENDIMENTO.TELAS.ATENDIMENTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.ATENDIMENTO.TELAS.CAPYS_BI.DS_PATH}
                component={RelatoriosBIAtendimentoCliente}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={ACESSOS.ATENDIMENTO.TELAS.CAPYS_BI.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.ATENDIMENTO.TELAS.CAPYS_BINPS.DS_PATH}
                component={RelatoriosBINPSAtendimento}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={ACESSOS.ATENDIMENTO.TELAS.CAPYS_BINPS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.ATENDIMENTO.TELAS.CAPYS_BICSAT.DS_PATH}
                component={RelatoriosBICSATAtendimento}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={ACESSOS.ATENDIMENTO.TELAS.CAPYS_BICSAT.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.ATENDIMENTO.TELAS.CAPYS_BIPERFILCLIENTES.DS_PATH}
                component={RelatoriosBIPerfilClientes}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={
                    ACESSOS.ATENDIMENTO.TELAS.CAPYS_BIPERFILCLIENTES.ID_TELA
                }
            />

            <PrivatedRoute
                path={ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATIVIDADES.DS_PATH}
                component={AgendaAtividadesComponent}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATIVIDADES.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.ATENDIMENTO.TELAS.PESQUISA_SATISFACAO.DS_PATH}
                component={PesquisaSatisfacaoAtendimentoCliente}
                isPrivate
                idModulo={ACESSOS.ATENDIMENTO.ID_MODULO}
                idTela={ACESSOS.ATENDIMENTO.TELAS.PESQUISA_SATISFACAO.ID_TELA}
            />

            <Route path="/Atendimento/:idModulo/" exact component={ModuloADS} />
        </Switch>
    );
}
